(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('change-field', {
            parent: 'entity',
            url: '/change-field?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changeField.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/change-field/change-fields.html',
                    controller: 'ChangeFieldController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changeField');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('change-field-detail', {
            parent: 'entity',
            url: '/change-field/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changeField.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/change-field/change-field-detail.html',
                    controller: 'ChangeFieldDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changeField');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ChangeField', function($stateParams, ChangeField) {
                    return ChangeField.get({id : $stateParams.id});
                }]
            }
        })
        .state('change-field.new', {
            parent: 'change-field',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-field/change-field-dialog.html',
                    controller: 'ChangeFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameGr: null,
                                isRelationship: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('change-field', null, { reload: true });
                }, function() {
                    $state.go('change-field');
                });
            }]
        })
        .state('change-field.edit', {
            parent: 'change-field',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-field/change-field-dialog.html',
                    controller: 'ChangeFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChangeField', function(ChangeField) {
                            return ChangeField.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('change-field', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('change-field.delete', {
            parent: 'change-field',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-field/change-field-delete-dialog.html',
                    controller: 'ChangeFieldDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ChangeField', function(ChangeField) {
                            return ChangeField.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('change-field', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
